export const getEventByType = (currentDate, eventType, events) => {
  return events?.[eventType]?.filter((evt) =>
    filterEventsCurrentDay(evt, currentDate),
  )
}

export const isToday = (currentDate) => {
  const today = new Date()
  return (
    today.getDate() == currentDate.getDate() &&
    today.getMonth() == currentDate.getMonth() &&
    today.getFullYear() == currentDate.getFullYear()
  )
}

export const addZeroBeginning = (n) => {
  return n < 10 ? '0' + n : n
}

const filterEventsCurrentDay = (event, currentDate) => {
  return (
    event?.date?.getUTCDate() == currentDate.getUTCDate() &&
    event?.date?.getMonth() == currentDate.getMonth() &&
    event?.date?.getFullYear() == currentDate.getFullYear()
  )
}
